import { render, staticRenderFns } from "./PostTime.vue?vue&type=template&id=283ba09c&scoped=true&"
import script from "./PostTime.vue?vue&type=script&lang=js&"
export * from "./PostTime.vue?vue&type=script&lang=js&"
import style0 from "./PostTime.vue?vue&type=style&index=0&id=283ba09c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283ba09c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
